<template>
    <div class="my-msg-box">
        <ul class="msg-box" @click="clickMsgBox">
            <li class="title-box">
                {{chatPersonName}}
            </li>

            <li class="content-box" v-html="chatMsgText">

            </li>

            <li>
                <div class="operation-box" >
                    <span>...</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup>

const props = defineProps(["chatPersonName", "chatMsgText"])
const emits = defineEmits(["clickMsgBox"])

function clickMsgBox() {
    emits("clickMsgBox")
}

</script>

<style scoped>

ul{
    list-style: none;
    padding-left: 0;
    margin: 0;
}

@media screen and (min-width: 520px) {
    .my-msg-box {
        position: fixed;
        width: 500px;
        min-height: 150px;
        background: #ffffff;
        left: calc(50vw - 250px);
        /*top: calc(50vh - 100px);*/
        /*left: 280px;*/
        top: 215px;
        z-index: 300;
        border-radius: 20px;
        border: #ddd 1px solid;
        font-size: 18px;
        color: #4e486d;
        font-weight: 800;
        text-align: left;
        cursor: default;
        user-select: none;

    }
}

@media screen and (max-width: 520px) {
    .my-msg-box {
        position: fixed;
        width: 80%;
        min-height: 150px;
        background: #ffffff;
        left: 10%;
        /*top: calc(50vh - 100px);*/
        /*left: 280px;*/
        /*top: 215px;*/
        top: 10%;
        z-index: 300;
        border-radius: 20px;
        border: #ddd 1px solid;
        font-size: 18px;
        color: #4e486d;
        font-weight: 800;
        text-align: left;
        cursor: default;
        user-select: none;

    }
}

.my-msg-box .msg-box {
    margin: auto;
    margin-top: 10px;
    width: 90%;
    height: calc(100% - 20px);
}

.my-msg-box .title-box {
    text-align: left;
    height: 30px;
    color: #438ae5;
}

.my-msg-box .content-box {
    height: calc(100% - 60px);
}

.my-msg-box .msg-box .operation-box {
    text-align: right;
    font-size: 20px;
    height: 30px;
}

</style>